import axios from "axios"
import qs from "qs"
// types
import { Pagination } from "types/api"
import { Language } from "types/i18n"

export type NotificationActionType = "Navigate_to_course" | "Navigate_to_question" | "Navigate_to_membership" | "null"

export type GetUserNotificationsResponse = {
  data: {
    id: number
    documentId: string
    title: string
    description: string
    actionContentId: string
    isRead: boolean
    createdAt: string
    notificationTemplate: {
      actionType: NotificationActionType
      icon: {
        url: string
      }
    }
  }[]
  meta: Pagination
}

export type GetUserUnreadNotificationResponse = {
  data: {
    isRead: boolean
  }[]
  meta: Pagination
}

export type ReadUserNotificationRequest = {
  documentId: string
}

export const USER_NOTIFICATIONS = {
  GET_USER_NOTIFICATIONS: "getUserNotifications",
  GET_USER_UNREAD_NOTIFICATION: "getUserUnreadNotification",
}

export const getUserNotifications = async () => {
  const url = `/my-notifications`

  const response = await axios.get<GetUserNotificationsResponse>(url)

  return response.data
}

export const readUserNotificationById = async ({ documentId }: ReadUserNotificationRequest) => {
  const url = `/user-notifications/${documentId}`

  const response = await axios.put(url, { data: { isRead: true } })

  return response.data
}

export const getUserUnreadNotification = async (locale: Language) => {
  const params = qs.stringify(
    {
      locale: locale,
      fields: ["isRead"],
      filters: {
        isRead: {
          $eqi: false,
        },
      },
    },
    { encodeValuesOnly: true }
  )

  const url = `/user-notifications?${params}`

  const response = await axios.get<GetUserUnreadNotificationResponse>(url)

  return response.data
}
